import cn from 'classname'
import FooterV2 from 'components/FooterV2/FooterV2'
import HeaderV2 from 'components/HeaderV2/HeaderV2'
import { useTranslation } from 'next-i18next'
import { ArticleJsonLd, NextSeo } from 'next-seo'
import Link from 'next/link'
import { renderDataToComponent } from '../../pages/api/contentful'
import styles from './BlogPostV2.module.css'

const BlogPostV2 = ({ data, locale, relatedBlogs }) => {
  const { t } = useTranslation('blog')

  return (
    <>
      <NextSeo
        title={`${data.fields.metaTitle} - Traqqie.com`}
        description={data.fields.metaDescription}
      />
      <ArticleJsonLd
        type="BlogPosting"
        url={`https://traqqie.com/${data.fields.locale}/blog/${data.sys.id}/${data.fields.slug}/`}
        title={data.fields.title}
        datePublished={data.fields.datePublished}
        authorName={data.fields.writtenBy}
        author={[
          {
            type: 'Organization',
            name: 'Traqqie.com',
            url: 'https://www.traqqie.com/',
          },
        ]}
        description={data.fields.shortDescription}
        isAccessibleForFree={true}
      />

      <div className="font-inter pt-[72px] md:pt-20 selection:bg-g400">
        <HeaderV2 locale={locale} />

        <div className="w-full flex flex-col items-center gap-y-12 py-24 px-6 md:gap-y-24 lg:px-[100px]">
          <h1 className="max-w-[960px] m-0 text-center text-g400 font-semibold text-3xl md:text-5xl md:leading-tight">
            {data.fields.title}
          </h1>
          <div className="max-w-[960px] w-full flex gap-x-16">
            <div className="flex flex-col gap-y-3 font-semibold">
              <span className="text-gr600 text-sm">
                {t('blog_reading_time')}
              </span>
              <span className="text-gr900 text-lg">
                {data.fields.readingTime} mins
              </span>
            </div>
            <div className="flex flex-col gap-y-3 font-semibold">
              <span className="text-gr600 text-sm">
                {' '}
                {t('blog_written_by')}
              </span>
              <span className="text-gr900 text-lg">
                {data.fields.writtenBy}
              </span>
            </div>
          </div>

          <div className="max-w-[960px] w-full flex flex-col">
            <img
              src={data.fields.previewImage.fields.file.url}
              alt={data.fields.previewImage.fields.title}
              className="w-full h-auto object-cover"
            />

            <div
              className={cn(
                'w-full mt-12 max-w-[720px] mx-auto md:mt-24',
                styles.content,
              )}
            >
              {renderDataToComponent(data.fields.content)}
            </div>
          </div>

          {relatedBlogs.length > 0 && (
            <div className="related-posts-section mt-16 max-w-[960px] w-full">
              <h2 className="text-2xl font-semibold text-g400 mb-8">
                {t('blog_related_posts')}
              </h2>
              <div className="flex flex-wrap gap-6">
                {relatedBlogs.map((blog) => (
                  <div key={blog.sys.id} className="related-post-card">
                    <Link href={`/blog/${blog.sys.id}/${blog.fields.slug}`}>
                      <a>
                        <h3 className="text-xl font-semibold">
                          {blog.fields.title}
                        </h3>
                        <p>{blog.fields.shortDescription}</p>
                      </a>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <FooterV2 locale={locale} />
      </div>
    </>
  )
}

export default BlogPostV2
